import { defineMessages } from '@jutro/locale';

export default defineMessages({
    signButton: {
        id: 'adac.labels.components.AdacConfigurableForm.Sign',
        defaultMessage: 'Sign'
    },
    errorReadingTemplate: {
        id: 'adac.labels.components.AdacConfigurableForm.Error Reading Template',
        defaultMessage: 'Something went wrong. Please try again later or contact our ADAC Ambulanze-Service using the below phone number:  +49 89 767676.'
    },
    errorMandatoryFields: {
        id: 'adac.labels.components.AdacConfigurableForm.Please fill out all mandatory information',
        defaultMessage: 'Please fill out all mandatory information.'
    },
    requiredFieldValidationMessage: {
        id: 'adac.labels.components.AdacConfigurableForm.This field is required',
        defaultMessage: 'This field is required.'
    },
    onlyTodayIsAvailableDateValidationMessage: {
        id: 'adac.labels.components.AdacConfigurableForm.Only today’s date is allowed',
        defaultMessage: 'Only today’s date is allowed.'
    },
    dateCannotBeFutureDateValidationMessage: {
        id: 'adac.labels.components.AdacConfigurableForm.Date cannot be in the future',
        defaultMessage: 'Date cannot be in the future.'
    },
    dateCannotBePastDateValidationMessage: {
        id: 'adac.labels.components.AdacConfigurableForm.Date cannot be in the past',
        defaultMessage: 'Date cannot be in the past.'
    },
    dateCannotBeBeforeValidationMessage: {
        id: 'adac.labels.components.AdacConfigurableForm.Date cannot be before',
        defaultMessage: 'The selected date cannot be before {minDate}.'
    },
    dateCannotBeAfterValidationMessage: {
        id: 'adac.labels.components.AdacConfigurableForm.Date cannot be after',
        defaultMessage: 'The selected date cannot be after {maxDate}'
    },
});
